import { render, staticRenderFns } from "./LanguageInfo.vue?vue&type=template&id=4cac9a98&functional=true&lang=pug&"
import script from "./LanguageInfo.vue?vue&type=script&lang=ts&"
export * from "./LanguageInfo.vue?vue&type=script&lang=ts&"
import style0 from "./LanguageInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports